import React from "react";
import { Box, Typography, Icon } from "@mui/material";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "../blocks/LoadingButton.js";
import { customEvent } from "src/utils/gtag.js";
import CalendarExplainerAnimation from "./CalendarExplainerAnimation.js";

const CalendarExplainerTile = ({
  onButtonClick,
  buttonText = "ADD TO CALENDAR",
  location = "timeline",
  sx,
  ...props
}) => {
  const theme = useTheme();

  const handleButtonClick = () => {
    // Track GA event
    customEvent({
      name: `user_click_a2c_explainer_${location}`,
      category: `${location}`,
      label: "Calendar Explainer Tile",
    });

    // Call original handler
    onButtonClick();
  };

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.text.tertiary}`,
        pt: 3,
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          textAlign: "center",
          px: 3,
          maxWidth: "300px",
          margin: "0 auto",
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            fontSize: "3rem",
            color: theme.palette.text.secondary,
            fontFamily: "Material Symbols Outlined",
            fontWeight: 100,
            display: "block",
            margin: "0 auto",
          }}
        >
          bolt
        </Box>

        {/* Title */}
        <Typography
          variant="title"
          sx={{
            mb: 3,
            color: theme.palette.text.primary,
            lineHeight: 1.2,
            fontWeight: 300,
          }}
        >
          Add Once.{" "}
          <Box component="span" sx={{ fontWeight: 600 }}>
            Stay Connected.
          </Box>
        </Typography>

        {/* Animation */}
        <CalendarExplainerAnimation />

        {/* Content Below Animation */}
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            mb: 2,
            color: theme.palette.text.secondary,
            maxWidth: "280px",
            mx: "auto",
          }}
        >
          Your calendar. Always accurate.
        </Typography>

        {/* CTA Button */}
        <LoadingButton
          variant="contained"
          size="shrinked"
          onClick={handleButtonClick}
          sx={{ mb: 2 }}
        >
          {buttonText}
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default CalendarExplainerTile;
